import Attachments, { IFilePath } from 'components/Attachments';
import { fetchFilesSilently } from 'components/Attachments/utils';
import BackButton from 'components/BackButton/ThemedBackButton';
import Flex from 'components/Flex';
import Text from 'components/Text';
import ContentItem from 'components/Website/ContentItem';
import HorizontalLine from 'components/Website/HorizontalLine';
import NewsBody from 'components/Website/Items/ItemBody';
import PublishDate from 'components/Website/Items/PublishDate';
import PageTitle from 'components/Website/PageTitle';
import SiteContent from 'components/Website/SiteContent';
import WysiwygContent from 'components/WysiwygContent';
import useFetchResource from 'hooks/useFetchResource';
import useTheme from 'hooks/useTheme';
import api from 'libs/api';
import { INewsItem } from 'pages/News/List';
import React, { FunctionComponent, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';

const NewsSpecific: FunctionComponent = () => {
  const { id } = useParams();
  const theme = useTheme();
  const { resource: news } = useFetchResource<INewsItem | undefined>({
    api: api.website.news.getOne,
    initialParams: {
      id,
    },
    initialValues: undefined,
    useNotFound: true,
  });

  const fetchFiles = useCallback(
    () =>
      fetchFilesSilently(
        api.website.news.getOne({ id }),
        (data: { resource: { files: IFilePath[] } }) => data.resource.files
      ),
    [id]
  );

  return (
    <SiteContent>
      <SpecificBackButtonContainer>
        <BackButton direction="left" />
      </SpecificBackButtonContainer>
      {news && (
        <>
          <SpecificContentItem>
            <SpecificPageTitle>{news.title}</SpecificPageTitle>
          </SpecificContentItem>
          <SpecificContentItem>
            <Flex>
              <PublishDate date={news.publicated_at} />
            </Flex>
          </SpecificContentItem>
          <ContentItem>
            <HorizontalLine />
          </ContentItem>
          <ContentItem>
            <WysiwygContent>
              <NewsBody dangerouslySetInnerHTML={{ __html: news.content }} />
            </WysiwygContent>
          </ContentItem>
          {news.files.length > 0 && (
            <ContentItem>
              <LabelText size="xs" weight="bold" color={theme.colors.dark}>
                Attachments
              </LabelText>
              <Attachments files={news.files} fetchFiles={fetchFiles} />
            </ContentItem>
          )}
        </>
      )}
    </SiteContent>
  );
};

const SpecificPageTitle = styled(PageTitle)`
  padding-top: 10px;
`;

const SpecificContentItem = styled(ContentItem)`
  padding-top: 10px;
  padding-bottom: 10px;
`;

const LabelText = styled(Text)`
  margin-bottom: 12px;
  ${(props) => props.theme.media.sm`
    margin-bottom: 0;
  `}
`;

const SpecificBackButtonContainer = styled(ContentItem)`
  padding: 60px 50px 0 50px;
`;

export default NewsSpecific;
